import { getToken } from "../utils/storage";

export const with_auth = () => ({
  Authorization: `${getToken()}`,
});
